import * as actions from './Actions';

/**
 * Parse discipline data to ensure consistent structure in the Redux store
 * @param {Object} disciplineData - The discipline data from API
 * @returns {Object} - Formatted discipline object
 */
const parseDiscipline = (disciplineData) => {
    // Get discipline ID (supporting both discipline_id and id formats)
    const disciplineId = disciplineData.discipline_id || disciplineData.id;
    
    // Use provided color or default blue
    const color = disciplineData.color || '#2196F3'; // Default blue
    
    // Get icon or use default
    const icon = disciplineData.icon; // Default icon
    
    // Ensure consistent structure for discipline objects
    return {
        discipline_id: disciplineId,
        name: disciplineData.name,
        color: color,
        icon: icon,
        unitCount: disciplineData.unitCount || 0,
        createdAt: disciplineData.createdAt || new Date().toISOString(),
        updatedAt: disciplineData.updatedAt || new Date().toISOString()
    };
};

const initialState = [];

const DisciplineReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.INITIALIZE_DISCIPLINES:
            return action.payload.map(discipline => parseDiscipline(discipline));
            
        case actions.ADD_DISCIPLINE:
            // Add new discipline to the state
            console.log('Adding discipline in reducer:', action.payload);
            return [...state, parseDiscipline(action.payload)];
            
        case actions.UPDATE_DISCIPLINE:
            // Update an existing discipline
            return state.map(discipline => 
                discipline.discipline_id === action.payload.discipline_id 
                ? parseDiscipline(action.payload) 
                : discipline
            );
            
        case actions.DELETE_DISCIPLINE:
            // Remove a discipline by ID
            return state.filter(discipline => discipline.discipline_id !== action.payload);
            
        case actions.CLEAR_DISCIPLINES_LIST:
            // Reset to initial state
            return initialState;
            
        default:
            return state;
    }
};

export default DisciplineReducer;
